import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faHome,
    faCalendarAlt,
    faCogs,
    faClipboard,
    faBook,
    faUsers,
    faUtensils,
    faSignOutAlt,
    faFileInvoiceDollar,
    faChalkboardTeacher,
} from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { logout } from '../redux/authSlice.jsx';
import { useDispatch } from 'react-redux';
import { jwtDecode } from 'jwt-decode';
import './Dashboard.css';
import { useSubscription } from "../Settings/SubscripitionChecker.jsx";

const ROLES = {
    HORECAMASTERS: 'HORECAMASTERS',
    BAAS: 'BAAS',
    FLOORMANAGER: 'FLOORMANAGER',
    HUMANRESOURCE: 'HUMANRESOURCE',
    MEDEWERKER: 'MEDEWERKER',
    KLOKSYSTEEM: 'KLOKSYSTEEM',
    CHEFKOK: 'CHEFKOK',
    AFWASSER: 'AFWASSER',
    KEUKENHULP: 'KEUKENHULP',
    SOUSCHEF: 'SOUSCHEF',
};

const menuItems = [
    { title: 'In en uit klokken', icon: faHome, color: '#6610f2', path: '/clockin', requiredRoles: [ROLES.BAAS, ROLES.HORECAMASTERS, ROLES.KLOKSYSTEEM], requiredSubscriptions: ['HorecaMasters Basic', 'Premium Subscription', 'HorecaMasters Ultimate'] },
    { title: 'Tafeltoewijzing', icon: faUtensils, color: '#28a745', path: '/tafeltoewijzing', requiredRoles: [ROLES.BAAS, ROLES.FLOORMANAGER, ROLES.HORECAMASTERS], requiredSubscriptions: ['Premium Subscription', 'HorecaMasters Ultimate'] },
    { title: 'Reserveringen', icon: faBook, color: '#dc3545', path: '/reserveringen', requiredRoles: [ROLES.BAAS, ROLES.FLOORMANAGER, ROLES.HORECAMASTERS], requiredSubscriptions: [ 'Premium Subscription', 'HorecaMasters Ultimate','Enterprise Subscription'] },
    { title: 'Planbord', icon: faCalendarAlt, color: '#17a2b8', path: '/schedule', requiredRoles: [ROLES.BAAS, ROLES.FLOORMANAGER, ROLES.HUMANRESOURCE, ROLES.MEDEWERKER, ROLES.HORECAMASTERS], requiredSubscriptions: ['HorecaMasters Basic', 'Premium Subscription', 'HorecaMasters Ultimate'] },
    { title: 'Medewerkers', icon: faUsers, color: '#007bff', path: '/EmployerDashboard', requiredRoles: [ROLES.BAAS, ROLES.FLOORMANAGER, ROLES.HUMANRESOURCE, ROLES.HORECAMASTERS], requiredSubscriptions: ['HorecaMasters Basic', 'Premium Subscription', 'HorecaMasters Ultimate'] },
    { title: 'Rapporten', icon: faClipboard, color: '#20c997', path: '/ReportPage', requiredRoles: [ROLES.BAAS, ROLES.FLOORMANAGER, ROLES.HUMANRESOURCE, ROLES.HORECAMASTERS], requiredSubscriptions: ['HorecaMasters Basic', 'Premium Subscription', 'HorecaMasters Ultimate'] },
    { title: 'Uren Correctie', icon: faClipboard, color: '#A020F0', path: '/urencorrectie', requiredRoles: [ROLES.MEDEWERKER], requiredSubscriptions: ['HorecaMasters Basic', 'Premium Subscription', 'HorecaMasters Ultimate' ]},
    { title: 'Offertegenerator', icon: faFileInvoiceDollar, color: '#ffc107', path: '/offertegenerator', requiredRoles: [ROLES.BAAS, ROLES.HORECAMASTERS], requiredSubscriptions: [ 'Premium Subscription', 'HorecaMasters Ultimate'] },
    { title: 'Instellingen', icon: faCogs, color: '#343a40', path: '/settings', requiredRoles: [ROLES.BAAS, ROLES.FLOORMANAGER, ROLES.HUMANRESOURCE,  ROLES.HORECAMASTERS], requiredSubscriptions: ['HorecaMasters Basic', 'Premium Subscription', 'HorecaMasters Ultimate'] },
    { title: 'E-learning', icon: faChalkboardTeacher, color: '#ff6347', path: '/courses', requiredRoles: [ROLES.BAAS, ROLES.HORECAMASTERS, ROLES.MEDEWERKER], requiredSubscriptions: ['HorecaMasters Ultimate','Enterprise Subscription'] }, // Unique color
    { title: 'Logout', icon: faSignOutAlt, color: '#ff5722', path: '/login', requiredRoles: [ROLES.BAAS, ROLES.FLOORMANAGER, ROLES.HUMANRESOURCE, ROLES.MEDEWERKER, ROLES.HORECAMASTERS] , requiredSubscriptions: ['HorecaMasters Basic', 'Premium Subscription', 'HorecaMasters Ultimate'] },
];

const Hoofdmenu = () => {
    const [role, setRole] = useState('');
    const dispatch = useDispatch();
    const subscription = useSubscription();

    useEffect(() => {
        const fetchAuthInfo = () => {
            const token = sessionStorage.getItem('authToken');
            if (token) {
                try {
                    const decodedToken = jwtDecode(token);
                    const userRole = Array.isArray(decodedToken.roles) ? decodedToken.roles[0] : decodedToken.roles;
                    setRole(userRole);
                    localStorage.setItem('role', userRole);
                } catch (error) {
                    console.error('Error decoding token:', error);
                }
            } else {
                console.error('No auth token found');
            }
        };

        fetchAuthInfo();
    }, []);

    const handleLogout = () => {
        dispatch(logout());
        localStorage.removeItem('authToken');
        window.location.href = '/login';
    };

    // ✅ Filter menu-items op basis van role én subscription
    const filteredMenuItems = menuItems.filter(item =>
        item.requiredRoles.includes(role) && item.requiredSubscriptions.includes(subscription)
    );


    const buttonStyle = {
        width: '325px', // Fixed width for buttons
        height: '80px', // Increased height for better touch targets
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '10px',
        color: 'white',
        cursor: 'pointer',
       marginTop: '20px',
    };

    return (
        <Container fluid className="hoofdmenu-container-fluid px-4 py-3">
            <Row className="mb-4 justify-content-start">
                <Col>
                    <h2 className="hoofdmenu-dashboard-title">Dashboard</h2>
                </Col>
            </Row>
            <Row xs={1} sm={2} md={3} lg={4} className="mb-4 justify-content-left">
                {filteredMenuItems.map((item, index) => (
                    <Col key={index} className="d-flex justify-content-center">
                        {item.title === 'Logout' ? (
                            <Card
                                onClick={handleLogout}
                                style={{ ...buttonStyle, backgroundColor: item.color }}
                                className="shadow-sm hover-lift"
                            >
                                <div>
                                    <FontAwesomeIcon icon={item.icon} size="2x" />
                                    <div className="mt-2 font-weight-bold">{item.title}</div>
                                </div>
                            </Card>
                        ) : item.path.startsWith('http') ? (
                            <a
                                href={item.path}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ textDecoration: 'none' }}
                            >
                                <Card
                                    style={{ ...buttonStyle, backgroundColor: item.color }}
                                    className="shadow-sm hover-lift"
                                >
                                    <div>
                                        <FontAwesomeIcon icon={item.icon} size="2x" />
                                        <div className="mt-2 font-weight-bold">{item.title}</div>
                                    </div>
                                </Card>
                            </a>
                        ) : (
                            <Link to={item.path} style={{ textDecoration: 'none' }}>
                                <Card
                                    style={{ ...buttonStyle, backgroundColor: item.color }}
                                    className="shadow-sm hover-lift"
                                >
                                    <div>
                                        <FontAwesomeIcon icon={item.icon} size="2x" />
                                        <div className="mt-2 font-weight-bold">{item.title}</div>
                                    </div>
                                </Card>
                            </Link>
                        )}
                    </Col>
                ))}
            </Row>
        </Container>
    );
};

export default Hoofdmenu;
